import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getUserData: state => {
    return qoalaStorage.getItem('u') ? parseIfJsonString(qoalaStorage.getItem('u')) : state.userData;
    // if (!state.userData) {
    //   return '';
    // }
    // if (state.userData === 'undefined') {
    //   return '';
    // }
    // if (typeof state.userData === 'string') {
    //   return JSON.parse(state.userData);
    // }
    // return state.userData;
  },
  getUserToken: state => state.userToken,
  getUserTokenRefresh: state => state.userTokenRefresh,
  getUserNotif: state => {
    return qoalaStorage.getItem('n') ? parseIfJsonString(qoalaStorage.getItem('n')) : state.userNotif;
    // if (!state.userNotif) {
    //   return '';
    // }
    // if (state.userNotif === 'undefined') {
    //   return '';
    // }
    // if (typeof state.userNotif === 'string') {
    //   return JSON.parse(state.userNotif);
    // }
    // return state.userNotif;
  },
  getUserNotifList: state => {
    return qoalaStorage.getItem('n') ? parseIfJsonString(qoalaStorage.getItem('n')) : state.userNotifs;
    // if (!state.userNotifs) {
    //   return '';
    // }
    // if (state.userNotifs === 'undefined') {
    //   return '';
    // }
    // if (typeof state.userNotifs === 'string') {
    //   return JSON.parse(state.userNotifs);
    // }
    // return state.userNotifs;
  },
  getUserPosition: state => {
    return qoalaStorage.getItem('position') ? parseIfJsonString(qoalaStorage.getItem('position')) : state.userPosition;
    // if (!state.userPosition) {
    //   return '';
    // }
    // if (state.userPosition === 'undefined') {
    //   return '';
    // }
    // if (typeof state.userPosition === 'string') {
    //   return JSON.parse(state.userPosition);
    // }
    // return state.userPosition;
  },
  getTempRegister: state => {
    return qoalaStorage.getItem('tempReg') ? parseIfJsonString(qoalaStorage.getItem('tempReg')) : state.tempRegister;
    // if (!state.tempRegister) {
    //   return '';
    // }
    // if (typeof state.tempRegister === 'string') {
    //   return JSON.parse(state.tempRegister);
    // }
    // return state.tempRegister;
  },
  getUserUnread: state => state.userUnread
};
